import React from 'react';

interface NotFoundProps {
    homePath?: string;
}

export const NotFound: React.FC<NotFoundProps> = ({
    homePath = '/'
}) => {
    return (
        /* Full-screen container using your background color #F4F4F2 */
        <div
            className="fixed inset-0 min-h-screen w-screen flex flex-col items-center justify-center p-6 text-center"
            style={{ backgroundColor: '#F4F4F2' }}
        >
            {/* Real Unsplash Dog Image - No border, no card wrapping */}
            <div className="w-64 h-64 md:w-80 md:h-80 mb-6 overflow-hidden rounded-lg shadow-md">
                <img
                    src="https://images.unsplash.com/photo-1543466835-00a7907e9de1?auto=format&fit=crop&q=80&w=600"
                    alt="Lost puppy looking up"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* 404 Error Code using logoHeading (#2F5E2E) */}
            <div
                className="text-8xl font-black tracking-tight select-none"
                style={{ color: '#2F5E2E' }}
            >
                404
            </div>

            {/* Heading using logoHeading (#2F5E2E) */}
            <h1
                className="mt-2 text-3xl font-extrabold tracking-tight md:text-4xl"
                style={{ color: '#2F5E2E' }}
            >
                Page Not Found
            </h1>

            {/* Description - Dark text styled directly against the background */}
            <p className="mt-4 max-w-md text-base text-gray-700 leading-relaxed font-medium">
                Oops! Looks like this page wandered off. The URL might be broken, or it was completely removed.
            </p>

            {/* CTA Button using mainBrandColor (#6DBE45) and accent (#A8D97B) */}
            <div className="mt-8">
                <a
                    href={homePath}
                    className="inline-flex justify-center items-center px-6 py-3 text-base font-bold rounded-xl text-white shadow-md transition-all duration-200 hover:scale-105"
                    style={{
                        backgroundColor: '#6DBE45',
                        boxShadow: '0 4px 14px rgba(109, 190, 69, 0.3)'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#5FB63F'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#6DBE45'}
                >
                    Back to Safety
                </a>
            </div>
        </div>
    );
};

export default NotFound;